import { Container, Row, Col, Card, CardBody } from "reactstrap";
import SessionText from "../../../Components/Student/SessionText/SessionText";
import StudentAudioRecording from "../../../Components/Student/AudioRecording/StudentAudioRecording";
import TeacherNotes from "../../../Components/Student/Notes/TeacherNotes";
import { EvaluationFooter } from "./components";
import { t } from "i18next";

const AccuracyStep = ({
  sessionsData,
  studentAudio,
  notes,
  calculatedWordCount,
  behaviorTypesData,
  localBehaviors,
  handleApplyBehavior,
  onBack,
  onNext,
}) => {
  return (
    <Container
      className="evaluation-content-body p-4"
      style={{ direction: "rtl", paddingBottom: "100px" }}
    >
      <Row className="g-4 align-items-start mb-4">
        <Col lg={8}>
          <Card
            className="shadow-sm border rounded-4 position-relative d-flex flex-column bg-white"
            style={{ borderColor: "#eef2f6" }}
          >
            <div className="p-4 border-bottom d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center gap-3">
                <img
                  src={sessionsData?.assessmentText?.coverPhoto}
                  alt={sessionsData?.title}
                  className="book-cover-image"
                />
                <div>
                  <h4 className="book-title-text mb-1 text-dark">
                    {sessionsData?.title || "Unknown"}
                  </h4>
                </div>
              </div>
              <span className="book-word-count">
                {calculatedWordCount} كلمة
              </span>
            </div>

            <div className="p-4 text-end">
              <div className="words-content-container pb-5">
                <SessionText
                  session={sessionsData}
                  miscueList={behaviorTypesData}
                  sessionAssessment={sessionsData?.assessmentText}
                  isEdit={true}
                  localBehaviors={localBehaviors}
                  onApplyBehavior={handleApplyBehavior}
                  hideTitle={true}
                />
              </div>
            </div>
          </Card>
        </Col>

        <Col lg={4}>
          <Card
            className="shadow-sm border rounded-4 mb-3 bg-white"
            style={{ borderColor: "#eef2f6" }}
          >
            <CardBody className="p-3">
              {studentAudio ? (
                <StudentAudioRecording src={studentAudio} title={"التسجيل"} />
              ) : (
                <div
                  className="text-muted text-center py-2"
                  style={{ fontSize: "14px" }}
                >
                  لا يوجد تسجيل صوتي متوفر
                </div>
              )}
            </CardBody>
          </Card>

          <TeacherNotes
            title={t("session.notes")}
            accuracy={notes?.accuracy}
            comprehension={notes?.comprehension}
          />
        </Col>
      </Row>

      <EvaluationFooter
        primaryText="الاستمرار الى تقييم الطلاقة"
        secondaryText="الرجوع"
        onPrimaryClick={onNext}
        onSecondaryClick={onBack}
        showSecondary={true}
      />
    </Container>
  );
};

export default AccuracyStep;
